import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v7';
import { Navigate } from 'react-router-dom';

import RequireAuth from './components/auth/RequireAuth';
import RequireCapability from './components/auth/RequireCapability';
import Layout from './components/Layout/Layout';
import Application from './pages/application/Application';
import ApplicationLayout from './pages/application/ApplicationLayout';
import ApplicationStatus from './pages/application/ApplicationStatus';
import Approvals from './pages/approvals/Approvals';
import ApprovalDetailsPage from './pages/approvals/ApprovalDetailsPage';
import Contract from './pages/contract/Contract';
import ContractDetailsTab from './pages/contract/ContractDetailsTab';
import ManageContracts from './pages/contract/ManageContracts';
import ContractRosterTab from './pages/contract/ContractRosterTab';
import ContractSettingsTab from './pages/contract/ContractSettingsTab';
import ErrorPage from './pages/ErrorPage';
import LandingPage from './pages/landingPage/landingPage';
import Profile from './pages/profile';
import { ROUTES } from './constants';
import LaborCategoriesTab from './pages/contract/LaborCategoriesTab';
import RosterOwnersTab from './pages/contract/RosterOwnersTab';

export const router = createBrowserRouter([
  {
    children: [
      {
        element: <LandingPage />,
        errorElement: <ErrorPage />,
        index: true,
      },
    ],
    element: <Layout />,
    errorElement: <ErrorPage />,
    path: '/',
  },
  {
    children: [
      {
        children: [
          {
            element: <Application />,
            index: true,
          },
          {
            element: (
              <RequireCapability capability='canAccessApplicationStatus'>
                <ApplicationStatus />
              </RequireCapability>
            ),
            path: 'status',
          },
        ],
        element: (
          <RequireCapability capability='canAccessApplication'>
            <ApplicationLayout />
          </RequireCapability>
        ),
        errorElement: <ErrorPage />,
        path: '/application',
      },
      {
        element: (
          <RequireCapability capability='canAccessContracts'>
            <ManageContracts />
          </RequireCapability>
        ),
        errorElement: <ErrorPage />,
        path: ROUTES.MANAGE_CONTRACT,
      },
      {
        element: (
          <Navigate
            replace
            to={ROUTES.MANAGE_CONTRACT}
          />
        ),
        path: '/contract',
      },
      {
        children: [
          {
            element: (
              <Navigate
                replace
                to='details'
              />
            ),
            index: true,
          },
          {
            element: <ContractDetailsTab />,
            path: 'details',
          },
          {
            element: <ContractRosterTab />,
            path: 'roster',
          },
          {
            element: <ContractSettingsTab />,
            path: 'settings',
          },
          {
            element: <RosterOwnersTab />,
            path: 'roster-owners',
          },
          {
            element: <LaborCategoriesTab />,
            path: 'labor-categories',
          },
        ],
        element: (
          <RequireCapability capability='canAccessContracts'>
            <Contract />
          </RequireCapability>
        ),
        errorElement: <ErrorPage />,
        path: '/contract/:id',
      },
      {
        element: <Profile />,
        errorElement: <ErrorPage />,
        path: '/profile',
      },
      {
        element: (
          <RequireCapability capability='canAccessApprovals'>
            <Approvals />
          </RequireCapability>
        ),
        errorElement: <ErrorPage />,
        path: ROUTES.APPROVALS,
      },
      {
        element: (
          <RequireCapability capability='canAccessApprovals'>
            <ApprovalDetailsPage />
          </RequireCapability>
        ),
        errorElement: <ErrorPage />,
        path: ROUTES.APPROVAL_APPLICATION_DETAILS,
      },
    ],
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    path: '/',
  },
]);
